var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTripDistance = function SvgTripDistance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M23.25 4.5c0 1.7-2.537 5.678-3.437 7.036a.374.374 0 0 1-.625 0C18.287 10.179 15.75 6.2 15.75 4.5a3.75 3.75 0 0 1 7.5 0m-18 3.75a4.5 4.5 0 0 1 4.5 4.5c0 1.921-2.688 5.577-3.909 7.138a.75.75 0 0 1-1.182 0C3.438 18.326.75 14.671.75 12.75a4.5 4.5 0 0 1 4.5-4.5m1.5 15L19.5 15"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M5.25 13.125a.375.375 0 0 1 0-.75m0 .75a.375.375 0 0 0 0-.75m14.25-7.5a.375.375 0 0 1 0-.75m0 .75a.375.375 0 0 0 0-.75"
  }))));
};
export default SvgTripDistance;